import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  standalone: false,
  template: `
<main class="container full-height d-flex flex-column justify-content-center">
  <p class="text-center text-secondary"><i class="fa fa-sad-tear fa-4x"></i></p>
  <h3 class="text-center"><span i18n>Error submitting order</span></h3>
    <p class="text-center" i18n>We're deeply sad about it, but something went wrong while submitting your order.</p>
    <p class="text-center" i18n>Please wait for a minute or two and try sending it again.</p>
    <p class="text-center">
      <button (click)="onBtOkay()" class="btn btn-danger">
        <i class="fas fa-redo"></i>&nbsp;<span i18n>Try again</span>
      </button>
    </p>
</main>
  `
})

export class SubmitErrorPage {

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }


  onBtOkay(): boolean {
    this.router.navigate(['/', 'checkout'])
    return false;
  }

}
